import { Box, Checkbox, Stack, Typography } from '@mui/material'

export const CheckboxInput = ({
  checked,
  onClick,
  text,
  disabled = false,
}: {
  checked: boolean
  onClick: () => void
  text: string
  disabled?: boolean
}) => {
  return (
    <Stack alignItems="center" direction="row" paddingBottom={1}>
      <Checkbox
        checked={checked}
        disabled={disabled}
        onClick={onClick}
        style={{ padding: 1, marginRight: 8 }}
      />
      <Box
        onClick={disabled ? undefined : onClick}
        className={`mt-0.5 ${disabled ? '' : 'cursor-pointer'}`}
      >
        <Typography variant="body-1">{text}</Typography>
      </Box>
    </Stack>
  )
}
